export function shopAuthHeader() {
    // return authorization header with jwt token
    let _token = JSON.parse(localStorage.getItem('shop_token'));
    if (_token) {
        return {
            'Authorization': 'Bearer ' + _token,
            'X-Requested-With': 'XMLHttpRequest',
        };
    } else {
        return {
            'X-Requested-With': 'XMLHttpRequest',
        };
    }
}